import React, {useEffect, useState} from 'react'
import {Card, CardBody, CardTitle, Col, Row} from "reactstrap";

// components
import SelectGeneric from "../../../components/select/selectGeneric";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {TT_CLOSE, TT_TRANSLATE_INTO_LANGUAGE} from "../../../components/i18n/toolTips";

// services
import {langProvider} from "../../../providers/langProvider";

// services
import {langService} from "../../../jwt/_services";
import {clearAppModulesResponse} from "../../../util/TranslateUtils";
import {fbChildPathService} from "../../../jwt/_services/firebase/fbChildPathService";
import AppModule from "./_appModule";

const TranslateView = ({
   data,
    onClose = () => {}
}) => {
    const {id, code='', name=''} = data
    const dbId = data?.app?.fbDataBase?.id
    const customFilter = { item: {
        toPreload: true,
        translateBase:null,
        enabledToEdit:null,
        saveHisTranslation:null,
    } }

    const [selectedLang, setSelectedLang] = useState(null)
    const [translationEnabled, setTranslationEnabled] = useState(false)
    const [applicationModules, setApplicationModules] = useState([])

    useEffect(() => {
        getApplicationModules()
    }, [data]);

    const getApplicationModules = async () => {
        const dataRequest = {
            code: 'lang',
            db: { id: dbId },
        }

        const response = await fbChildPathService.search(0,1000, dataRequest)

        setApplicationModules(clearAppModulesResponse(response?.data, code))
    }


    const handleTranslate = () => {
        const requestData = {
            "header": { "app": code },
            "item":  { "langCode": selectedLang }
        }

        langService.translateApp(requestData)
        onClose();
    }

    return <Card className={'card-modal-small'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className={'fa fa-language'}/> &nbsp; {name}
            <div className="top-right">
                <GenericButton
                    style={'danger-secondary'}
                    toolTip={TT_CLOSE}
                    icon={'fa-times'}
                    permission={'search'}
                    onClick={onClose}
                />
            </div>
        </CardTitle>
        <CardBody>
            <Row>
                <Col sm={7}>
                    <label>{TT_TRANSLATE_INTO_LANGUAGE}</label>
                    <SelectGeneric
                        initialValue={selectedLang}
                        setExternalValue={(val)=> {
                            setTranslationEnabled(!!val)
                            setSelectedLang(val)
                        }}
                        customFilter={customFilter}
                        provider={langProvider}
                    />
                </Col>
                <Col>
                   <div className={'pt-2em'}>
                        <GenericButton
                            style={'primary'}
                            label={'Traducción Completa'}
                            onClick={handleTranslate}
                            disabled={!translationEnabled}
                        />
                   </div>
                </Col>
            </Row>
            <br/>
        </CardBody>
        <CardBody className={'card-body-modal'}>
            {
                applicationModules.map(({id:module, title}) => <AppModule
                    key={module}
                    app={id}
                    module={module}
                    title={title}
                    lang={selectedLang}
                />)
            }
        </CardBody>
    </Card>
}

export default TranslateView